module.exports = __webpack_public_path__ + "static/media/girl-shrug.9e2dc370.jpg";